/**
 * iframeをタグで囲む（レスポンシブ対応）
 */
export class IframeWrap {

  /**
   * コンストラクタ
   * @param content 対象を内包する要素
   */
  constructor(content: string) {
    const $iframe: JQuery = $(content).find('iframe');

    if (! $iframe[0]) {
      return;
    }

    $iframe.each((index: number, element: Element): void => {
      const $element: JQuery = $(element);

      $element.wrap('<div class="fn-iframe"></div>');
    });
  }

}
